"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMop_jericho = exports.updateMop_jericho = exports.createMop_jericho = exports.decoratePromise = void 0;
var tslib_1 = require("tslib");
var BaseApi_1 = tslib_1.__importDefault(require("../../../API/BaseApi"));
var interfaces_1 = require("../interfaces");
var index_1 = require("../../../Config/index");
var util_1 = require("../util");
var transformMop_1 = require("../../common/transforms/transformMop");
function decoratePromise(mopPromise) {
    return mopPromise
        .then(function (result) {
        var responseData = result.data;
        var errors = responseData.errors, errors2 = responseData.errors2;
        var regularErr = (0, util_1.normalizeRegularErr)(errors);
        var fieldErr = (0, util_1.normalizeFieldErr)(errors2);
        var concatErr = regularErr.concat(fieldErr);
        var baseResponse = {
            errors: concatErr,
            data: responseData,
        };
        return baseResponse;
    })
        .catch(function (error) { return JSON.parse(error.message); });
}
exports.decoratePromise = decoratePromise;
function createMop_jericho(mop) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var transformedMop, response;
        return tslib_1.__generator(this, function (_a) {
            transformedMop = (0, transformMop_1.transformMop)(mop);
            response = BaseApi_1.default.doPostRequestToChegg(index_1.createMopUrl, transformedMop, null, interfaces_1.CREATE_TIMEOUT);
            return [2 /*return*/, decoratePromise(response)];
        });
    });
}
exports.createMop_jericho = createMop_jericho;
function updateMop_jericho(mop) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var transformedMop, response;
        return tslib_1.__generator(this, function (_a) {
            transformedMop = (0, transformMop_1.transformMop)(mop);
            response = BaseApi_1.default.doPostRequestToChegg(index_1.updateMopUrl, transformedMop, null, interfaces_1.CREATE_TIMEOUT);
            return [2 /*return*/, decoratePromise(response)];
        });
    });
}
exports.updateMop_jericho = updateMop_jericho;
function getMop_jericho(filter) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var response;
        return tslib_1.__generator(this, function (_a) {
            if ((filter === null || filter === void 0 ? void 0 : filter.paymentMethods) && filter.paymentMethods.length === 0) {
                return [2 /*return*/, Promise.resolve({
                        data: [],
                        errors: null,
                        success: true,
                    })];
            }
            response = BaseApi_1.default.doPostRequestToChegg(index_1.getMopUrl, filter ? filter : {}, null, interfaces_1.EXISTING_PAYMENTS_TIMEOUT);
            return [2 /*return*/, response
                    .then(function (result) {
                    var data = result.data;
                    var paymentMethods = data.paymentMethods, errors = data.errors;
                    return {
                        data: paymentMethods,
                        errors: errors ? [errors] : null,
                    };
                })
                    .catch(function (error) { return JSON.parse(error.message); })];
        });
    });
}
exports.getMop_jericho = getMop_jericho;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/methodOfPaymentAPI/jericho/index.js
// module id = 3390
// module chunks = 11